module.exports = __webpack_public_path__ + "img/1551581725.6c5e8c6b.jpg";